module.exports = __webpack_public_path__ + "static/media/wallet_connect.1e924115.svg";